export default __webpack_public_path__ + "static/media/email.4bcda980.svg";